import { render, staticRenderFns } from "./LiveShowPlayersPointHistory.vue?vue&type=template&id=fbc5e250&"
import script from "./LiveShowPlayersPointHistory.vue?vue&type=script&lang=js&"
export * from "./LiveShowPlayersPointHistory.vue?vue&type=script&lang=js&"
import style0 from "./LiveShowPlayersPointHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports